

import {
  ADD_NOTIFICATION, ADD_NOTIFICATION_REQUEST, HOVER, LOWER_HEIGHT, REMOVE_NOTIFICATION, REMOVE_NOTIFICATION_REQUEST,
  START_NOTIFICATION_TRANSITION, UNHOVER
} from "./notifications-action-types";

export const addNotificationRequest = ({ status, message }) => ({ type: ADD_NOTIFICATION_REQUEST, status, message });
export const addNotification = ({ status, message, id }) => ({ type: ADD_NOTIFICATION, status, message, id });
export const startNotificationTransition = id => ({ type: START_NOTIFICATION_TRANSITION, id });
export const removeNotificationRequest = id => ({ type: REMOVE_NOTIFICATION_REQUEST, id });
export const removeNotification = id => ({ type: REMOVE_NOTIFICATION, id });

export const hover = id => ({ type: HOVER, id });
export const unhover = id => ({ type: UNHOVER, id });


// WEBPACK FOOTER //
// ./src/modules/notifications/notifications-action-creators.js